/**
 * 移动系统：读输入 -> 求速度 -> 分轴解算碰撞 -> 更新动画状态。
 * 碰撞源有两类：瓦片（墙体）与器物（家具）。
 */

const BOX_W = 14;   // 碰撞盒宽（脚部）
const BOX_H = 10;   // 碰撞盒高（脚部一小段，允许"贴"着家具上部走）

function blockedByTiles(tm, x, y) {
  if (!tm) return false;
  const ts = tm.tileSize;
  const l = x - BOX_W / 2, r = x + BOX_W / 2;
  const t = y - BOX_H, b = y;
  const pts = [[l, t], [r, t], [l, b], [r, b]];
  for (const [px, py] of pts) {
    if (tm.isSolidAtPixel(px, py)) return true;
  }
  return false;
}

function blockedByProps(scene, x, y) {
  const ts = scene.tilemap ? scene.tilemap.tileSize : 40;
  const l = x - BOX_W / 2, r = x + BOX_W / 2;
  const t = y - BOX_H, b = y;
  for (const p of scene.props) {
    if (!p.solid) continue;
    const px = p.gx * ts, py = p.gy * ts;
    const pw = p.w * ts, ph = p.h * ts;
    // 家具的"占地"只算下半部分，视觉上可以走到它背后
    const solidTop = py + ph * 0.45;
    if (r > px + 2 && l < px + pw - 2 && b > solidTop && t < py + ph) return true;
  }
  return false;
}

export function canStand(scene, x, y) {
  return !blockedByTiles(scene.tilemap, x, y) && !blockedByProps(scene, x, y);
}

export const movementSystem = {
  name: 'movement',
  update(dt, ctx) {
    const { scene, input } = ctx;
    const players = scene.query('transform', 'velocity', 'player');
    if (!players.length) return;

    for (const e of players) {
      const t = e.transform;
      const v = e.velocity;
      const p = e.player;
      // 开车时移动交给 vehicle 系统：这里是乘客（其实是司机），出手就该乱套
      if (e.veh) { v.x = 0; v.y = 0; continue; }
      // 坐着 / 躺着时走不动：先起身（pose 系统会检测方向键并扶正）
      if (e.pose && e.pose.state !== 'stand') {
        v.x = 0; v.y = 0;
        e.anim.moving = false;
        e.anim.phase = 0;
        continue;
      }

      const ax = input.axis();

      const running = input.isDown('Shift');
      const speed = (running ? p.runSpeed : p.speed) * (p.buff || 1);
      v.x = ax.x * speed;
      v.y = ax.y * speed;

      const moving = ax.x !== 0 || ax.y !== 0;
      if (moving) {
        // 朝向：优先取主轴
        if (Math.abs(ax.x) > Math.abs(ax.y)) e.anim.facing = ax.x > 0 ? 'right' : 'left';
        else e.anim.facing = ax.y > 0 ? 'down' : 'up';
        e.anim.phase += dt * (running ? 14 : 9);
      } else {
        e.anim.phase = 0;
      }
      e.anim.moving = moving;

      if (!moving) continue;

      // 脚下已经被占住（多半是布置时把家具挪到了脚底，或读档落点在家具里）：
      // 这种时候两轴都会被判成撞墙，人就永远卡死了，所以先放行一步，走出去为止
      const stuck = !canStand(scene, t.x, t.y);

      // 分轴推进，撞墙时该轴速度归零，仍可沿墙滑动
      const nx = t.x + v.x * dt;
      if (stuck || canStand(scene, nx, t.y)) t.x = nx;
      const ny = t.y + v.y * dt;
      if (stuck || canStand(scene, t.x, ny)) t.y = ny;
    }
  },
};

export { BOX_W, BOX_H };
